$(document).ready(function(){   
    $('.html img').removeAttr('height');
});
